
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MainLayoutComponent } from './shared/layout/app-layouts/main-layout.component';
import { AuthLayoutComponent } from './shared/layout/app-layouts/auth-layout.component';
import { AuthorizeGuard } from './core/guards/authorize.guard';
import { PrivacyPolicyComponent } from './shared/disclaimer/privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from './shared/disclaimer/terms-of-use/terms-of-use.component';
import { AboutUsComponent } from './shared/disclaimer/about-us/about-us.component';
import { Permission } from './shared/models/Authentication/permission.model';
import { UnauthorizedComponent } from './shared/layout/unauthorized/unauthorized.component';


const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthorizeGuard],
    children: [
      {
        // path: '',
        // data: { claimType: Permission.IsHealthUser },       
        // //data: { claimType: Permission.IsLifeUser },
        // redirectTo: 'dashboard',
        // pathMatch: 'full',
        // canActivateChild: [AuthorizeGuard]
        path: '',
        loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivateChild: [AuthorizeGuard]
      },
      {
        path: 'home',
        loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule),
        canActivateChild: [AuthorizeGuard]
      },
      {
        path: 'profile',
        loadChildren: () => import('./features/profile/profile.module').then(m => m.ProfileModule),
        canActivateChild: [AuthorizeGuard]
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivateChild: [AuthorizeGuard]
      },
      {
        path: 'quote',
        loadChildren: () => import('./features/quotation/quotation.module').then(m => m.QuotationModule),
        canActivateChild: [AuthorizeGuard]
      },
      {
        path: 'test',
        loadChildren: () => import('./features/test/test.module').then(m => m.TestModule),
        canActivateChild: [AuthorizeGuard]
      },
      {
        path: 'health/listing',
        loadChildren: () => import('./features/reports/health/health.reports.module').then(m => m.HealthReportsModule),
        canActivateChild: [AuthorizeGuard]
      },
      {
        path: 'life/listing',
        loadChildren: () => import('./features/reports/life/life.reports.module').then(m => m.LifeReportsModule),
        canActivateChild: [AuthorizeGuard]
      },
      {
        path: 'privacy',
        component: PrivacyPolicyComponent
      },
      {
        path: 'termsofuse',
        component: TermsOfUseComponent
      },
      {
        path: 'aboutus',
        component: AboutUsComponent
      },
      { path: 'unauthorized', component: UnauthorizedComponent },
      {
        path: 'admin',
        loadChildren: () => import('./features/administration/administration.module').then(m => m.AdministrationModule),
        canActivateChild: [AuthorizeGuard]
      }
    ]
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }

